module.exports = __webpack_public_path__ + "media/images/icon__nativeAppShare@3x-7d6db60ad5dd06890a7accf1fef84b8c.png";